/* global  moment, _ */
import './style.less';
import { orderBy } from 'lodash';

export default function($log, $stateParams, $location, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  switch ($stateParams.tab) {
    case 'past':
      vm.activeTab = 1;
      break;
    default:
      vm.activeTab = 0;
  }

  vm.changeTab = tab => $location.search('tab', tab);

  function activate() {
    $log.debug('Event Progress Component Activated');
    vm.loaded = false;
    vm.error = {};

    ApiClass.eventsGet(
      { eventType: false, pastEvents: false },
      {},
      {
        queryParams: {
          registration: true,
          waitlist: true,
          profile_uid,
          'filters:includeArchived': true,
          'filters:includePastEvents': true,
          'filters:requireRegistrationORInvitation': true,
          ...[
            'course_id',
            'course_name',
            'delivery_date',
            'delivery_location_time_zone_id',
            'event_id',
            'hours'
          ].reduce((acc, prop) => {
            acc[`projection:${prop}`] = 1;

            return acc;
          }, {})
        }
      }
    )
      .then(({ data: { events } }) => {
        const filteredEvents = events.reduce(
          (obj, event) => {
            const upcoming = new Date(event.delivery_date).getTime() > new Date().getTime();
            if (upcoming) obj.upcoming.push(event);
            else obj.past.push(event);

            return obj;
          },
          { upcoming: [], past: [] }
        );

        vm.events = {
          upcoming: orderBy(filteredEvents.upcoming, ['sortTime'], ['desc']),
          past: orderBy(filteredEvents.past, ['sortTime'], ['desc'])
        };

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/progressEvents/controller.js